<template>
  <md-snackbar
    :ref="refName"
    md-position="bottom center"
    :md-duration="duration"
    class="snackbar"
    :class="color"
  >
    <span>
      <slot />
    </span>
    <md-button
      v-if="actionButtonEnabled"
      @click="firstButtonAction"
    >
      {{ firstButtonText }}
    </md-button>
    <md-button
      v-if="actionButtonEnabled"
      @click="secondButtonAction"
    >
      {{ secondButtonText }}
    </md-button>
  </md-snackbar>
</template>

<script>
export default {
  props: {
    refName: String,
    firstButtonText: {
      default: 'Não',
      type: String
    },
    secondButtonText: {
      default: 'Sim',
      type: String
    },
    actionButtonEnabled: {
      default: true,
      type: Boolean
    },
    color: {
      default: 'red'
    },
    duration: {
      default: '9999999',
      type: String
    }
  },
  beforeDestroy () {
    this.close()
  },
  methods: {
    close () {
      this.$refs[this.refName].close()
    },
    open () {
      this.$refs[this.refName].open()
    },
    firstButtonAction () {
      this.$emit('first-cta')
    },
    secondButtonAction () {
      this.$emit('second-cta')
    }
  }
}
</script>

<style lang="scss">
.snackbar {
  &-yellow.md-snackbar {
    bottom: -10px;

    .md-snackbar {
      &-container {
        min-width: 910px;
        padding: 13px 24px;
        background-color: #fff1b6;
        color: #f15a24;
        border: solid 2px #fbb03b;
      }

      &-content {
        display: flex;
        flex-direction: row;
        height: 12px;
        letter-spacing: -0.5px;
      }
    }

    .md-button {
      color: #f15a24;
      padding: 0 10px;
      margin: -11px 0 0 25px;

      &:last-child {
        margin-left: 2px;
        color: #f15a24;
      }
    }
  }

  &-red.md-snackbar {
    bottom: -10px;

    .md-snackbar {
      &-container {
        min-width: 700px;
        padding: 13px 24px;
        background-color: #7c0a02;
      }
      &-content {
        display: flex;
        flex-direction: row;
        height: 12px;
        letter-spacing: -0.5px;
      }
    }

    .md-button {
      color: rgba(255, 255, 255, 0.5);
      padding: 0 10px;
      margin: -11px 0 0 25px;

      &:last-child {
        margin-left: 13px;
        color: #e1e1e1;
      }
    }
  }

  &-purple-center {
    &.md-snackbar {
      bottom: -10px;

      .md-snackbar {
        &-container {
          width: auto;
          min-width: auto;
          padding: 13px 24px;
          background-color: #802e54;
        }
        &-content {
          display: flex;
          flex-direction: row;
          height: 12px;
          justify-content: center;

          a {
            color: #e1e1e1;
            cursor: pointer;

            &:hover {
              color: #fff;
              text-decoration: none;
            }
          }
        }
      }

      .md-button {
        color: rgba(255, 255, 255, 0.5);
        padding: 0 10px;
        margin: -11px 0 0 25px;

        &:last-child {
          margin-left: -105px;
          color: #e1e1e1;
        }
      }
    }
  }

  &-regular.md-snackbar {
    bottom: -10px;

    .md-snackbar {
      &-container {
        width: 628px;
        padding: 13px 24px;
      }
      &-content {
        display: flex;
        flex-direction: row;
        height: 12px;
        letter-spacing: -0.5px;
      }
    }

    .md-button {
      color: #f37b43;
      padding: 0 10px;
      margin: -11px 0 0 25px;

      &:last-child {
        margin-left: 2px;
        color: #f37b43;
      }
    }
  }
}
</style>

